import { render, staticRenderFns } from "./BranchUpdate.vue?vue&type=template&id=07774312&scoped=true&"
import script from "./BranchUpdate.vue?vue&type=script&lang=js&"
export * from "./BranchUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07774312",
  null
  
)

export default component.exports